// // import React, { useState, useEffect, useContext } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { postData, getData, serverURL } from "../../../../services/Fetchnodeservices";
// // import { Image as ImageIcon, Plus, Sparkles, X, ChevronLeft, ChevronRight, Percent } from 'lucide-react'; 
// // import AIScanModal from "./AIScanModal";
// // import EditItemModal from "./EditItemModal";
// // // ⚠️ IMPORTANT: Adjust this path to exactly match where your ThemeContext is located!
// // import { ThemeContext } from "../../../../context/ThemeContext"; 

// // const Admin = () => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
  
// //   // 🛡️ SAFE CONTEXT CONSUMPTION WITH FALLBACK
// //   const themeContext = useContext(ThemeContext);
// //   const isDarkMode = themeContext?.currentTheme === 'dark';
  
// //   const fallbackTheme = {
// //     background: isDarkMode ? "#0a0e1a" : "#f8fafc",
// //     surface: isDarkMode ? "#141b2f" : "#ffffff",
// //     border: isDarkMode ? "#2a3f5f" : "#e2e8f0",
// //     textPrimary: isDarkMode ? "#f8fafc" : "#0f172a",
// //     textSecondary: isDarkMode ? "#cbd5e1" : "#334155",
// //     textMuted: isDarkMode ? "#94a3b8" : "#64748b",
// //     primary: "#6366f1",
// //     primaryLight: "rgba(99, 102, 241, 0.15)",
// //     primaryGradient: "linear-gradient(135deg, #6366f1, #8b5cf6)",
// //   };

// //   const brandTheme = themeContext?.theme || fallbackTheme;
  
// //   // 🔴 UNIFIED THEME OBJECT
// //   const theme = {
// //     bg: brandTheme.background,
// //     surface: brandTheme.surface,
// //     surfaceAlt: isDarkMode ? "#1e2747" : "#f1f5f9",
// //     border: brandTheme.border,
// //     text: brandTheme.textPrimary,
// //     textSub: brandTheme.textSecondary,
// //     textMuted: brandTheme.textMuted,
// //     primary: brandTheme.primary,
// //     primaryLight: brandTheme.primaryLight || `${brandTheme.primary}25`,
// //     gradient: brandTheme.primaryGradient || `linear-gradient(135deg, ${brandTheme.primary}, #8b5cf6)`,
// //     success: "#34d399",
// //     warning: "#fbbf24",
// //     danger: "#f87171",
// //     shadow: isDarkMode ? "0 8px 16px rgba(0,0,0,0.3)" : "0 8px 16px rgba(0,0,0,0.08)",
// //     gradientCard: isDarkMode ? "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)" : "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
// //   };

// //   const [menuItems, setMenuItems] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [search, setSearch] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const itemsPerPage = 10;
  
// //   const [showAIScanModal, setShowAIScanModal] = useState(false);
// //   const [showEditModal, setShowEditModal] = useState(false);
// //   const [selectedItem, setSelectedItem] = useState(null);
// //   const [vendorMenus, setVendorMenus] = useState([]);
// //   const [preSelectedImage, setPreSelectedImage] = useState(null);

// //   const [markupCommission, setMarkupCommission] = useState(20);
// //   const [profitCommission, setProfitCommission] = useState(20);
// //   const [showCommissionModal, setShowCommissionModal] = useState(false);
// //   const [tempCommission, setTempCommission] = useState(20);

// //   // ✅ FIXED: Get data from location.state or sessionStorage
// //   const designation_id = location.state?.designation_id || 
// //     JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
  
// //   const [restaurantName, setRestaurantName] = useState(
// //     location.state?.restaurantName || 
// //     JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName || 
// //     ''
// //   );

// //   const fetchRestaurantDetails = async () => {
// //     if (!designation_id) return;
// //     try {
// //       const response = await getData(`restaurant/Restrunts/${designation_id}`);
// //       if (response.status && response.data) {
// //         const nameFromApi = response.data.organisation_name || response.data.name || '';
// //         if (nameFromApi) setRestaurantName(nameFromApi);

// //         const markup = parseFloat(response.data.commission_calc) ?? parseFloat(response.data.comission) ?? 20;
// //         const profit = parseFloat(response.data.comission) ?? 20;
// //         setMarkupCommission(markup);
// //         setProfitCommission(profit);
// //       }
// //     } catch (e) {
// //       console.error("Failed to fetch restaurant details:", e);
// //     }
// //   };

// //   const fetchMenu = async () => {
// //     if (!designation_id) return;
// //     setLoading(true);
// //     try {
// //       const response = await postData("restaurant/Menubydesignation_id", { designation_id });
// //       let itemsArray = [];
// //       if (Array.isArray(response) && response[0]?.items) {
// //         itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
// //       }
// //       setMenuItems(itemsArray);
// //     } catch (err) { 
// //       console.error(err); 
// //     } finally { 
// //       setLoading(false); 
// //     }
// //   };

// //   const fetchVendorUploadedMenus = async () => {
// //     try {
// //       const resp = await getData(`menuScanner/requests-by-restaurant/${designation_id}`);
// //       if (resp.success) {
// //         const allFiles = [];
// //         resp.data.forEach(req => {
// //           const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
// //           files.forEach(f => {
// //             if (f.type === 'image') allFiles.push({ filename: f.name, date: req.created_at });
// //           });
// //         });
// //         setVendorMenus(allFiles);
// //       }
// //     } catch (e) { 
// //       console.error(e); 
// //     }
// //   };

// //   useEffect(() => { 
// //     fetchRestaurantDetails();
// //     fetchMenu(); 
// //     fetchVendorUploadedMenus();
// //   }, [designation_id]);

// //   const handleDelete = async (productId) => {
// //     if (!window.confirm("Bhai, pakka delete karna hai?")) return;
// //     try {
// //       const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
// //       if (resp.success) fetchMenu();
// //     } catch (e) { 
// //       console.error(e); 
// //     }
// //   };

// //   const handleScanVendorImage = (filename) => {
// //     setPreSelectedImage(filename);
// //     setShowAIScanModal(true);
// //   };

// //   const handleUpdateCommission = async () => {
// //     try {
// //       const resp = await postData(`restaurant/updaterestaurant/${designation_id}`, {
// //         commission_calc: tempCommission
// //       });
// //       if (resp.success) {
// //         setMarkupCommission(tempCommission);
// //         setShowCommissionModal(false);
// //         fetchMenu();
// //       } else {
// //         alert("Failed to update commission");
// //       }
// //     } catch (e) {
// //       console.error(e);
// //       alert("Error updating commission");
// //     }
// //   };

// //   const getMenuCustomerVendor = (item) => {
// //     let base = parseFloat(item.base_price) || parseFloat(item.requested_price) || 0;
// //     if (!base && item.price) base = Math.round(item.price / 1.2);
// //     if (!base) return { menu: 0, customer: 0, vendor: 0, profit: 0 };
// //     const customer = Math.round(base * (1 + markupCommission / 100));
// //     const profit = Math.round(customer * (profitCommission / 100));
// //     const vendor = customer - profit;
// //     return { menu: base, customer, vendor, profit };
// //   };

// //   const getVariantPricing = (variant) => {
// //     let base = parseFloat(variant.base_price) || parseFloat(variant.actual_price) || 0;
// //     if (!base && variant.item_price_variant) base = Math.round(variant.item_price_variant / 1.2);
// //     if (!base) return { menu: 0, customer: 0, vendor: 0, profit: 0 };
// //     const customer = Math.round(base * (1 + markupCommission / 100));
// //     const profit = Math.round(customer * (profitCommission / 100));
// //     const vendor = customer - profit;
// //     return { menu: base, customer, vendor, profit };
// //   };

// //   const filteredItems = menuItems.filter(item =>
// //     item.name?.toLowerCase().includes(search.toLowerCase()) ||
// //     item.category?.toLowerCase().includes(search.toLowerCase())
// //   );

// //   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
// //   const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

// //   const styles = {
// //     container: { minHeight: "100vh", background: theme.bg, padding: "32px 40px", color: theme.text, fontFamily: 'Inter, sans-serif', transition: "background 0.3s ease" },
// //     card: { background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: theme.shadow, backgroundImage: theme.gradientCard, transition: "all 0.3s ease" },
// //     vendorGrid: { display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '32px' },
// //     vendorImgBox: { minWidth: '120px', height: '160px', borderRadius: '12px', border: `2px dashed ${theme.border}`, background: theme.surfaceAlt, overflow: 'hidden', cursor: 'pointer', position: 'relative', transition: "all 0.2s" },
// //     table: { width: "100%", borderCollapse: "collapse" },
// //     th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: theme.primary, background: theme.surfaceAlt, textTransform: "uppercase", borderBottom: `1px solid ${theme.border}` },
// //     td: { padding: "14px 16px", borderBottom: `1px solid ${theme.border}`, fontSize: "13px", color: theme.textSub },
// //     badge: { display: 'block', fontSize: '10px', background: theme.surfaceAlt, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${theme.border}` },
// //     img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${theme.border}` },
// //     paginationBtn: (active) => ({ padding: "8px 16px", borderRadius: "10px", border: `1px solid ${active ? theme.primary : theme.border}`, background: active ? theme.primary : theme.surface, color: active ? "white" : theme.textSub, cursor: "pointer", margin: "0 4px", fontSize: '12px', fontWeight: 600, transition: "all 0.2s" }),
// //     modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: "blur(4px)" },
// //     modalContent: { background: theme.surface, padding: '30px', borderRadius: '20px', maxWidth: '400px', width: '90%', border: `1px solid ${theme.border}`, boxShadow: theme.shadow }
// //   };

// //   return (
// //     <div style={styles.container}>
// //       <style>{`
// //         tr:hover { background: ${theme.primary}08 !important; } 
// //         input:focus { border-color: ${theme.primary} !important; outline: none; box-shadow: 0 0 0 3px ${theme.primaryLight}; }
// //         .vendor-box:hover .scan-overlay { opacity: 1 !important; }
// //         .vendor-box:hover { border-color: ${theme.primary} !important; transform: translateY(-2px); }
// //         ::-webkit-scrollbar { height: 6px; }
// //         ::-webkit-scrollbar-thumb { background: ${theme.border}; border-radius: 10px; }
// //       `}</style>
      
// //       <button style={{ background: theme.surfaceAlt, color: theme.primary, border: `1px solid ${theme.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px', display:'flex', alignItems:'center', gap:'8px', fontWeight: 600, transition: "all 0.2s" }} 
// //         onClick={() => navigate(-1)}
// //         onMouseEnter={(e) => { e.currentTarget.style.background = theme.border; }}
// //         onMouseLeave={(e) => { e.currentTarget.style.background = theme.surfaceAlt; }}>
// //         <ChevronLeft size={18}/> Back
// //       </button>

// //       <div style={styles.card}>
// //         <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'20px'}}>
// //             <div>
// //                 <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: theme.gradient, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName || 'Menu'}</h1>
// //                 <p style={{color: theme.textMuted, margin:'5px 0 0 0'}}>Manage dishes and scan new menus</p>
// //             </div>
// //             <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
// //               <button 
// //                 onClick={() => { setTempCommission(markupCommission); setShowCommissionModal(true); }} 
// //                 style={{ background: theme.surfaceAlt, border: `1px solid ${theme.border}`, color: theme.text, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600, transition: "all 0.2s" }}
// //                 onMouseEnter={(e) => { e.currentTarget.style.background = theme.border; }}
// //                 onMouseLeave={(e) => { e.currentTarget.style.background = theme.surfaceAlt; }}
// //               >
// //                  <Percent size={16} color={theme.primary} />
// //                  Markup: {markupCommission}% | Profit: {profitCommission}%
// //               </button>
// //               <button onClick={() => {setPreSelectedImage(null); setShowAIScanModal(true)}} style={{ background: theme.gradient, color: 'white', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', boxShadow: `0 4px 12px ${theme.primary}40`, transition: "all 0.2s" }}
// //                 onMouseEnter={(e) => { e.currentTarget.style.filter = "brightness(1.1)"; e.currentTarget.style.transform = "translateY(-1px)"; }}
// //                 onMouseLeave={(e) => { e.currentTarget.style.filter = "brightness(1)"; e.currentTarget.style.transform = "translateY(0)"; }}>
// //                   <Sparkles size={16}/> AI Scan Menu
// //               </button>
// //             </div>
// //         </div>
// //       </div>

// //       <div style={{marginBottom: '15px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px', color: theme.text}}>
// //          <ImageIcon size={18} color={theme.primary}/> Menu Pages & PDFs (Sent by Vendor)
// //       </div>
// //       <div style={styles.vendorGrid}>
// //         {vendorMenus.length > 0 ? vendorMenus.map((menu, i) => (
// //           <div key={i} className="vendor-box" style={styles.vendorImgBox} onClick={() => handleScanVendorImage(menu.filename)}>
// //               <img src={`${serverURL}/uploads/${menu.filename}`} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="menu-page" onError={(e) => { e.target.src = "https://via.placeholder.com/120x160?text=Menu+Page"; }}/>
// //               <div className="scan-overlay" style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'0.3s'}}>
// //                   <Sparkles size={20} color="white"/>
// //               </div>
// //               <div style={{position:'absolute', bottom:0, width:'100%', padding:'4px', background:'rgba(0,0,0,0.7)', fontSize:'10px', color:'white', textAlign:'center'}}>
// //                   Page {i+1}
// //               </div>
// //           </div>
// //         )) : [1,2,3,4,5].map(n => (
// //           <div key={n} style={{...styles.vendorImgBox, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color: theme.textMuted, opacity: 0.5}}>
// //               <Plus size={24} />
// //               <span style={{fontSize:'10px', marginTop:'5px'}}>Page {n}</span>
// //           </div>
// //         ))}
// //       </div>

// //       <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: theme.surface, border: `1px solid ${theme.border}`, color: theme.text, marginBottom: '24px', fontSize: '14px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

// //       <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
// //         <table style={styles.table}>
// //           <thead>
// //             <tr>
// //               <th style={styles.th}>Dish</th>
// //               <th style={styles.th}>Item Details</th>
// //               <th style={styles.th}>Menu Price</th>
// //               <th style={styles.th}>Customer Price</th>
// //               <th style={styles.th}>Vendor Earns</th>
// //               <th style={styles.th}>ZaptoDoor Profit</th>
// //               <th style={styles.th}>Type</th>
// //               <th style={styles.th}>Actions</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {currentItems.map((item, idx) => {
// //               let variants = [];
// //               try {
// //                 variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
// //               } catch(e) { variants = []; }

// //               if (variants.length === 0) {
// //                 const { menu, customer, vendor, profit } = getMenuCustomerVendor(item);
// //                 return (
// //                   <tr key={idx}>
// //                     <td style={styles.td}>
// //                       <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
// //                     </td>
// //                     <td style={styles.td}>
// //                       <div style={{ fontWeight: 700, color: theme.text, fontSize: '15px' }}>{item.name}</div>
// //                       <div style={{ fontSize: '11px', color: theme.textMuted }}>{item.description?.substring(0,40)}...</div>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ fontWeight: 600, color: theme.text }}>₹{menu.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: theme.warning, fontWeight: 700 }}>₹{customer.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: theme.success, fontWeight: 700 }}>₹{vendor.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: theme.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <div style={{ display: 'flex', gap: '10px' }}>
// //                         <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: theme.primary, cursor: 'pointer', padding: '4px', borderRadius: '6px', transition: "all 0.2s" }}
// //                           onMouseEnter={(e) => e.currentTarget.style.background = theme.primaryLight}
// //                           onMouseLeave={(e) => e.currentTarget.style.background = 'none'}><Sparkles size={14} /></button>
// //                         <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: theme.danger, cursor: 'pointer', padding: '4px', borderRadius: '6px', transition: "all 0.2s" }}
// //                           onMouseEnter={(e) => e.currentTarget.style.background = `${theme.danger}20`}
// //                           onMouseLeave={(e) => e.currentTarget.style.background = 'none'}><X size={14}/></button>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 );
// //               }

// //               return variants.map((v, vIdx) => {
// //                 const { menu, customer, vendor, profit } = getVariantPricing(v);
// //                 return (
// //                   <tr key={`${idx}-${vIdx}`}>
// //                     {vIdx === 0 && (
// //                       <>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
// //                         </td>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <div style={{ fontWeight: 700, color: theme.text, fontSize: '15px' }}>{item.name}</div>
// //                           <div style={{ fontSize: '11px', color: theme.textMuted }}>{item.description?.substring(0,40)}...</div>
// //                         </td>
// //                       </>
// //                     )}
// //                     <td style={styles.td}>
// //                       <span style={{ fontWeight: 600, color: theme.text }}>{v.unit_value || 'Price'}: ₹{menu.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: theme.warning, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{customer.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: theme.success, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{vendor.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: theme.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
// //                     </td>
// //                     {vIdx === 0 && (
// //                       <>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
// //                         </td>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <div style={{ display: 'flex', gap: '10px' }}>
// //                             <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: theme.primary, cursor: 'pointer', padding: '4px', borderRadius: '6px', transition: "all 0.2s" }}
// //                               onMouseEnter={(e) => e.currentTarget.style.background = theme.primaryLight}
// //                               onMouseLeave={(e) => e.currentTarget.style.background = 'none'}><Sparkles size={14} /></button>
// //                             <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: theme.danger, cursor: 'pointer', padding: '4px', borderRadius: '6px', transition: "all 0.2s" }}
// //                               onMouseEnter={(e) => e.currentTarget.style.background = `${theme.danger}20`}
// //                               onMouseLeave={(e) => e.currentTarget.style.background = 'none'}><X size={14}/></button>
// //                           </div>
// //                         </td>
// //                       </>
// //                     )}
// //                   </tr>
// //                 );
// //               });
// //             })}
// //           </tbody>
// //         </table>

// //         <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${theme.border}`, background: theme.surfaceAlt }}>
// //             <div style={{fontSize:'12px', color: theme.textMuted}}>
// //                 Showing {currentItems.length} of {filteredItems.length} items
// //             </div>
// //             <div style={{ display: 'flex', alignItems: 'center' }}>
// //                 <button 
// //                   disabled={currentPage === 1} 
// //                   onClick={() => setCurrentPage(currentPage - 1)}
// //                   style={{...styles.paginationBtn(false), opacity: currentPage === 1 ? 0.5 : 1}}
// //                   onMouseEnter={(e) => { if (currentPage !== 1) e.currentTarget.style.background = theme.primaryLight; }}
// //                   onMouseLeave={(e) => { if (currentPage !== 1) e.currentTarget.style.background = theme.surface; }}
// //                 >
// //                     <ChevronLeft size={16}/>
// //                 </button>
// //                 {[...Array(totalPages)].map((_, i) => (
// //                     <button 
// //                       key={i} 
// //                       onClick={() => setCurrentPage(i + 1)}
// //                       style={styles.paginationBtn(currentPage === i + 1)}
// //                       onMouseEnter={(e) => { if (currentPage !== i + 1) e.currentTarget.style.background = theme.primaryLight; }}
// //                       onMouseLeave={(e) => { if (currentPage !== i + 1) e.currentTarget.style.background = theme.surface; }}
// //                     >
// //                         {i + 1}
// //                     </button>
// //                 ))}
// //                 <button 
// //                   disabled={currentPage === totalPages} 
// //                   onClick={() => setCurrentPage(currentPage + 1)}
// //                   style={{...styles.paginationBtn(false), opacity: currentPage === totalPages ? 0.5 : 1}}
// //                   onMouseEnter={(e) => { if (currentPage !== totalPages) e.currentTarget.style.background = theme.primaryLight; }}
// //                   onMouseLeave={(e) => { if (currentPage !== totalPages) e.currentTarget.style.background = theme.surface; }}
// //                 >
// //                     <ChevronRight size={16}/>
// //                 </button>
// //             </div>
// //         </div>
// //       </div>
      
// //       <AIScanModal 
// //         isOpen={showAIScanModal} 
// //         onClose={() => {setShowAIScanModal(false); setPreSelectedImage(null);}} 
// //         designationId={designation_id} 
// //         restaurantName={restaurantName} 
// //         onItemsAdded={fetchMenu}
// //         preSelectedServerImage={preSelectedImage} 
// //         markupCommission={markupCommission} 
// //         profitCommission={profitCommission} 
// //         theme={theme}
// //         isDark={isDarkMode}
// //       />
// //       {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} theme={theme} ts={theme} isDark={isDarkMode} />}

// //       {showCommissionModal && (
// //         <div style={styles.modalOverlay} onClick={() => setShowCommissionModal(false)}>
// //           <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
// //             <h3 style={{ margin: '0 0 15px 0', color: theme.text }}>Set Commission for {restaurantName}</h3>
// //             <input 
// //               type="number" 
// //               value={tempCommission} 
// //               onChange={(e) => setTempCommission(Number(e.target.value))}
// //               style={{ width: '100%', padding: '12px', borderRadius: '8px', border: `1px solid ${theme.border}`, background: theme.bg, color: theme.text, fontSize: '16px', outline: "none", transition: "all 0.2s" }}
// //               min="0" max="100"
// //               onFocus={(e) => { e.target.style.borderColor = theme.primary; e.target.style.boxShadow = `0 0 0 3px ${theme.primaryLight}`; }}
// //               onBlur={(e) => { e.target.style.borderColor = theme.border; e.target.style.boxShadow = 'none'; }}
// //             />
// //             <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'flex-end' }}>
// //               <button onClick={() => setShowCommissionModal(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: theme.surfaceAlt, color: theme.textSub, cursor: 'pointer', fontWeight: 500, transition: "all 0.2s" }}
// //                 onMouseEnter={(e) => e.currentTarget.style.background = theme.border}
// //                 onMouseLeave={(e) => e.currentTarget.style.background = theme.surfaceAlt}>Cancel</button>
// //               <button onClick={handleUpdateCommission} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: theme.gradient, color: '#fff', cursor: 'pointer', fontWeight: 600, boxShadow: `0 4px 6px -1px ${theme.primary}30`, transition: "all 0.2s" }}
// //                 onMouseEnter={(e) => e.currentTarget.style.filter = "brightness(1.1)"}
// //                 onMouseLeave={(e) => e.currentTarget.style.filter = "brightness(1)"}>Save</button>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Admin;



// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { postData, getData, serverURL } from "../../../../services/Fetchnodeservices";
// import { Image as ImageIcon, Plus, Sparkles, X, ChevronLeft, ChevronRight, Percent } from 'lucide-react'; 
// import AIScanModal from "./AIScanModal";
// import EditItemModal from "./EditItemModal";

// const getThemeStyles = (isDark) => {
//   const themes = {
//     dark: {
//       background: "#0a0e1a", surface: "#141b2f", surfaceLighter: "#1e2747",
//       border: "#2a3f5f", borderAccent: "#3d5a8c", textPrimary: "#f8fafc",
//       textSecondary: "#cbd5e1", textMuted: "#94a3b8", primary: "#60a5fa",
//       primaryLight: "#93c5fd", primaryDark: "#1e40af", success: "#34d399",
//       successLight: "#6ee7b7", error: "#f87171", warning: "#fbbf24",
//       gradientPrimary: "linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%)",
//       gradientCard: "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)",
//       shadowMd: "0 8px 16px rgba(0,0,0,0.2)",
//     },
//     light: {
//       background: "#f8fafc", surface: "#ffffff", surfaceLighter: "#f1f5f9",
//       border: "#e2e8f0", borderAccent: "#cbd5e1", textPrimary: "#0f172a",
//       textSecondary: "#334155", textMuted: "#64748b", primary: "#3b82f6",
//       primaryLight: "#60a5fa", primaryDark: "#1e40af", success: "#10b981",
//       successLight: "#34d399", error: "#ef4444", warning: "#f59e0b",
//       gradientPrimary: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
//       gradientCard: "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
//       shadowMd: "0 8px 16px rgba(0,0,0,0.1)",
//     },
//   };
//   return themes[isDark ? 'dark' : 'light'];
// };

// const Admin = ({ isDark = true }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const ts = getThemeStyles(isDark);

//   const [menuItems, setMenuItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
  
//   const [showAIScanModal, setShowAIScanModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [vendorMenus, setVendorMenus] = useState([]);
//   const [preSelectedImage, setPreSelectedImage] = useState(null);

//   // const [commission, setCommission] = useState(20);

//   const [markupCommission, setMarkupCommission] = useState(20);
// const [profitCommission, setProfitCommission] = useState(20);
//   const [showCommissionModal, setShowCommissionModal] = useState(false);
//   const [tempCommission, setTempCommission] = useState(20);

//   const designation_id = location.state?.designation_id || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
//   // const restaurantName = location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName;
// const [restaurantName, setRestaurantName] = useState(
//   location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName || ''
// );

//   const fetchRestaurantDetails = async () => {
//   if (!designation_id) return;
//   try {
//     const response = await getData(`restaurant/Restrunts/${designation_id}`);
//     if (response.status && response.data) {
//       // ✅ Restaurant name – priority: organisation_name, then name
//       const nameFromApi = response.data.organisation_name || response.data.name || '';
//       if (nameFromApi) setRestaurantName(nameFromApi);

//       const markup = parseFloat(response.data.commission_calc) ?? parseFloat(response.data.comission) ?? 20;
//       const profit = parseFloat(response.data.comission) ?? 20;
//       setMarkupCommission(markup);
//       setProfitCommission(profit);
//     }
//   } catch (e) {
//     console.error("Failed to fetch restaurant details:", e);
//   }
// };

//   const fetchMenu = async () => {
//     if (!designation_id) return;
//     setLoading(true);
//     try {
//       const response = await postData("restaurant/Menubydesignation_id", { designation_id });
//       let itemsArray = [];
//       if (Array.isArray(response) && response[0]?.items) {
//         itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
//       }
//       setMenuItems(itemsArray);
//     } catch (err) { console.error(err); }
//     finally { setLoading(false); }
//   };

//   const fetchVendorUploadedMenus = async () => {
//     try {
//       const resp = await getData(`menuScanner/requests-by-restaurant/${designation_id}`);
//       if (resp.success) {
//         const allFiles = [];
//         resp.data.forEach(req => {
//           const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
//           files.forEach(f => {
//             if (f.type === 'image') allFiles.push({ filename: f.name, date: req.created_at });
//           });
//         });
//         setVendorMenus(allFiles);
//       }
//     } catch (e) { console.error(e); }
//   };

//   useEffect(() => { 
//     fetchRestaurantDetails();
//     fetchMenu(); 
//     fetchVendorUploadedMenus();
//   }, [designation_id]);

//   const handleDelete = async (productId) => {
//     if (!window.confirm("Bhai, pakka delete karna hai?")) return;
//     try {
//       const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
//       if (resp.success) fetchMenu();
//     } catch (e) { console.error(e); }
//   };

//   const handleScanVendorImage = (filename) => {
//     setPreSelectedImage(filename);
//     setShowAIScanModal(true);
//   };

//  const handleUpdateCommission = async () => {
//   try {
//     const resp = await postData(`restaurant/updaterestaurant/${designation_id}`, {
//       commission_calc: tempCommission
//     });
//     if (resp.success) {
//       setMarkupCommission(tempCommission);   // ✅ yeh sahi hai
//       setShowCommissionModal(false);
//       fetchMenu();
//     } else {
//       alert("Failed to update commission");
//     }
//   } catch (e) {
//     console.error(e);
//     alert("Error updating commission");
//   }
// };

//   // ===== PRICING HELPERS – FIXED =====
//   // Menu price is ALWAYS `base_price` (or `requested_price` as fallback)
//   // Never derive menu from customer using current commission
//   const getMenuCustomerVendor = (item) => {
//   let base = parseFloat(item.base_price) || parseFloat(item.requested_price) || 0;
//   if (!base && item.price) base = Math.round(item.price / 1.2); // fallback
//   if (!base) return { menu: 0, customer: 0, vendor: 0, profit: 0 };
//   const customer = Math.round(base * (1 + markupCommission / 100));
//   const profit = Math.round(customer * (profitCommission / 100));
//   const vendor = customer - profit;
//   return { menu: base, customer, vendor, profit };
// };

//   // Variants – same logic
//   const getVariantPricing = (variant) => {
//   let base = parseFloat(variant.base_price) || parseFloat(variant.actual_price) || 0;
//   if (!base && variant.item_price_variant) base = Math.round(variant.item_price_variant / 1.2);
//   if (!base) return { menu: 0, customer: 0, vendor: 0, profit: 0 };
//   const customer = Math.round(base * (1 + markupCommission / 100));
//   const profit = Math.round(customer * (profitCommission / 100));
//   const vendor = customer - profit;
//   return { menu: base, customer, vendor, profit };
// };

//   const filteredItems = menuItems.filter(item =>
//     item.name?.toLowerCase().includes(search.toLowerCase()) ||
//     item.category?.toLowerCase().includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
//   const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

//   const styles = {
//     container: { minHeight: "100vh", background: ts.background, padding: "32px 40px", color: ts.textPrimary, fontFamily: 'Inter, sans-serif' },
//     card: { background: ts.surface, border: `1px solid ${ts.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: ts.shadowMd, backgroundImage: ts.gradientCard },
//     vendorGrid: { display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '32px' },
//     vendorImgBox: { minWidth: '120px', height: '160px', borderRadius: '12px', border: `2px dashed ${ts.border}`, background: ts.surfaceLighter, overflow: 'hidden', cursor: 'pointer', position: 'relative' },
//     table: { width: "100%", borderCollapse: "collapse" },
//     th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: ts.primary, background: ts.surfaceLighter, textTransform: "uppercase", borderBottom: `1px solid ${ts.border}` },
//     td: { padding: "14px 16px", borderBottom: `1px solid ${ts.border}`, fontSize: "13px", color: ts.textSecondary },
//     badge: { display: 'block', fontSize: '10px', background: ts.surfaceLighter, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${ts.border}` },
//     img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${ts.border}` },
//     paginationBtn: (active) => ({ padding: "8px 16px", borderRadius: "10px", border: `1px solid ${active ? ts.primary : ts.border}`, background: active ? ts.primary : ts.surface, color: active ? "white" : ts.textSecondary, cursor: "pointer", margin: "0 4px", fontSize: '12px', fontWeight: 600 }),
//     modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
//     modalContent: { background: ts.surface, padding: '30px', borderRadius: '20px', maxWidth: '400px', width: '90%', border: `1px solid ${ts.border}`, boxShadow: ts.shadowMd }
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         tr:hover { background: ${ts.primary}08 !important; } 
//         input:focus { border-color: ${ts.primary} !important; outline: none; }
//         .vendor-box:hover .scan-overlay { opacity: 1 !important; }
//         ::-webkit-scrollbar { height: 6px; }
//         ::-webkit-scrollbar-thumb { background: ${ts.border}; borderRadius: 10px; }
//       `}</style>
      
//       <button style={{ background: ts.surfaceLighter, color: ts.primary, border: `1px solid ${ts.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px', display:'flex', alignItems:'center', gap:'8px' }} onClick={() => navigate(-1)}>
//         <ChevronLeft size={18}/> Back
//       </button>

//       <div style={styles.card}>
//         <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'20px'}}>
//             <div>
//                 <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: ts.gradientPrimary, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName}</h1>
//                 <p style={{color: ts.textMuted, margin:'5px 0 0 0'}}>Manage dishes and scan new menus</p>
//             </div>
//             <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
//               <button 
//   onClick={() => { setTempCommission(markupCommission); setShowCommissionModal(true); }} 
//                 style={{ background: ts.surfaceLighter, border: `1px solid ${ts.border}`, color: ts.textPrimary, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}
//               >
//                  <Percent size={16} color={ts.primary} />
//   Markup: {markupCommission}% | Profit: {profitCommission}%
//               </button>
//               <button onClick={() => {setPreSelectedImage(null); setShowAIScanModal(true)}} style={{ background: ts.primary, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Sparkles size={16}/> AI Scan Menu
//               </button>
//             </div>
//         </div>
//       </div>

//       <div style={{marginBottom: '15px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px'}}>
//          <ImageIcon size={18} color={ts.primary}/> Menu Pages & PDFs (Sent by Vendor)
//       </div>
//       <div style={styles.vendorGrid}>
//         {vendorMenus.length > 0 ? vendorMenus.map((menu, i) => (
//           <div key={i} className="vendor-box" style={styles.vendorImgBox} onClick={() => handleScanVendorImage(menu.filename)}>
//               <img src={`${serverURL}/uploads/${menu.filename}`} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="menu-page" onError={(e) => { e.target.src = "https://via.placeholder.com/120x160?text=Menu+Page"; }}/>
//               <div className="scan-overlay" style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'0.3s'}}>
//                   <Sparkles size={20} color="white"/>
//               </div>
//               <div style={{position:'absolute', bottom:0, width:'100%', padding:'4px', background:'rgba(0,0,0,0.7)', fontSize:'10px', color:'white', textAlign:'center'}}>
//                   Page {i+1}
//               </div>
//           </div>
//         )) : [1,2,3,4,5].map(n => (
//           <div key={n} style={{...styles.vendorImgBox, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color: ts.textMuted, opacity: 0.5}}>
//               <Plus size={24} />
//               <span style={{fontSize:'10px', marginTop:'5px'}}>Page {n}</span>
//           </div>
//         ))}
//       </div>

//       <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: ts.surface, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '24px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

//       <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>Dish</th>
//               <th style={styles.th}>Item Details</th>
//               <th style={styles.th}>Menu Price</th>
//               <th style={styles.th}>Customer Price</th>
//               <th style={styles.th}>Vendor Earns</th>
//               <th style={styles.th}>ZaptoDoor Profit</th>
//               <th style={styles.th}>Type</th>
//               <th style={styles.th}>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentItems.map((item, idx) => {
//               let variants = [];
//               try {
//                 variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
//               } catch(e) { variants = []; }

//               if (variants.length === 0) {
//                 const { menu, customer, vendor, profit } = getMenuCustomerVendor(item);
//                 return (
//                   <tr key={idx}>
//                     <td style={styles.td}>
//                       <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
//                     </td>
//                     <td style={styles.td}>
//                       <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
//                       <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ fontWeight: 600, color: ts.textPrimary }}>₹{menu.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.warning, fontWeight: 700 }}>₹{customer.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.success, fontWeight: 700 }}>₹{vendor.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <div style={{ display: 'flex', gap: '10px' }}>
//                         <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
//                         <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               }

//               return variants.map((v, vIdx) => {
//                 const { menu, customer, vendor, profit } = getVariantPricing(v);
//                 return (
//                   <tr key={`${idx}-${vIdx}`}>
//                     {vIdx === 0 && (
//                       <>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
//                         </td>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
//                           <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
//                         </td>
//                       </>
//                     )}
//                     <td style={styles.td}>
//                       <span style={{ fontWeight: 600, color: ts.textPrimary }}>{v.unit_value || 'Price'}: ₹{menu.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.warning, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{customer.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.success, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{vendor.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
//                     </td>
//                     {vIdx === 0 && (
//                       <>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
//                         </td>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <div style={{ display: 'flex', gap: '10px' }}>
//                             <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
//                             <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
//                           </div>
//                         </td>
//                       </>
//                     )}
//                   </tr>
//                 );
//               });
//             })}
//           </tbody>
//         </table>

//         <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${ts.border}`, background: ts.surfaceLighter }}>
//             <div style={{fontSize:'12px', color: ts.textMuted}}>
//                 Showing {currentItems.length} of {filteredItems.length} items
//             </div>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <button 
//                   disabled={currentPage === 1} 
//                   onClick={() => setCurrentPage(currentPage - 1)}
//                   style={{...styles.paginationBtn(false), opacity: currentPage === 1 ? 0.5 : 1}}
//                 >
//                     <ChevronLeft size={16}/>
//                 </button>
//                 {[...Array(totalPages)].map((_, i) => (
//                     <button 
//                       key={i} 
//                       onClick={() => setCurrentPage(i + 1)}
//                       style={styles.paginationBtn(currentPage === i + 1)}
//                     >
//                         {i + 1}
//                     </button>
//                 ))}
//                 <button 
//                   disabled={currentPage === totalPages} 
//                   onClick={() => setCurrentPage(currentPage + 1)}
//                   style={{...styles.paginationBtn(false), opacity: currentPage === totalPages ? 0.5 : 1}}
//                 >
//                     <ChevronRight size={16}/>
//                 </button>
//             </div>
//         </div>
//       </div>
      
//       <AIScanModal 
//         isOpen={showAIScanModal} 
//         onClose={() => {setShowAIScanModal(false); setPreSelectedImage(null);}} 
//         designationId={designation_id} 
//         restaurantName={restaurantName} 
//         onItemsAdded={fetchMenu}
//         preSelectedServerImage={preSelectedImage} 
//         // commission={commission}
//         markupCommission={markupCommission} 
//   profitCommission={profitCommission} 
//       />
//       {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} ts={ts} />}

//       {showCommissionModal && (
//         <div style={styles.modalOverlay} onClick={() => setShowCommissionModal(false)}>
//           <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
//             <h3 style={{ margin: '0 0 15px 0', color: ts.textPrimary }}>Set Commission for {restaurantName}</h3>
//             <input 
//               type="number" 
//               value={tempCommission} 
//               onChange={(e) => setTempCommission(Number(e.target.value))}
//               style={{ width: '100%', padding: '12px', borderRadius: '8px', border: `1px solid ${ts.border}`, background: ts.background, color: ts.textPrimary, fontSize: '16px' }}
//               min="0" max="100"
//             />
//             <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'flex-end' }}>
//               <button onClick={() => setShowCommissionModal(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: ts.surfaceLighter, color: ts.textSecondary, cursor: 'pointer' }}>Cancel</button>
//               <button onClick={handleUpdateCommission} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: ts.primary, color: '#fff', cursor: 'pointer' }}>Save</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// Admin.defaultProps = {
//   isDark: true
// };

// export default Admin;


import React, { useEffect, useMemo, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Image as ImageIcon,
  Plus,
  Sparkles,
  X,
  Trash2,
  ChevronLeft,
  ChevronRight,
  Percent,
} from "lucide-react";

import {
  getData,
  postData,
  putData,
  serverURL,
} from "../../../../services/Fetchnodeservices";
import { ThemeContext } from "../../../../context/ThemeContext";
import AIScanModal from "./AIScanModal";
import EditItemModal from "./EditItemModal";
import AddItemModal from "./AddItemModal";

const Admin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const themeContext = useContext(ThemeContext);
  const [showAddItemModal, setShowAddItemModal] = useState(false);

  const isDark = themeContext?.currentTheme === "dark";

  const fallbackTheme = {
    background: isDark ? "#0f172a" : "#f8fafc",
    surface: isDark ? "#1e293b" : "#ffffff",
    surfaceLighter: isDark ? "#334155" : "#f1f5f9",
    border: isDark ? "#475569" : "#e2e8f0",
    borderAccent: isDark ? "#64748b" : "#cbd5e1",
    textPrimary: isDark ? "#f8fafc" : "#0f172a",
    textSecondary: isDark ? "#cbd5e1" : "#334155",
    textMuted: isDark ? "#94a3b8" : "#64748b",
    primary: "#6366f1",
    primaryLight: "rgba(99, 102, 241, 0.15)",
    primaryDark: "#4f46e5",
    primaryGradient: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  };

  const brandTheme = themeContext?.theme || fallbackTheme;

  const ts = {
    background: brandTheme.background || fallbackTheme.background,
    surface: brandTheme.surface || fallbackTheme.surface,
    surfaceLighter:
      brandTheme.surfaceLighter ||
      (isDark ? "#334155" : "#f1f5f9"),

    border: brandTheme.border || fallbackTheme.border,
    borderAccent: brandTheme.borderAccent || brandTheme.border || fallbackTheme.border,

    textPrimary: brandTheme.textPrimary || fallbackTheme.textPrimary,
    textSecondary: brandTheme.textSecondary || fallbackTheme.textSecondary,
    textMuted: brandTheme.textMuted || fallbackTheme.textMuted,

    primary: brandTheme.primary || fallbackTheme.primary,
    primaryLight: brandTheme.primaryLight || fallbackTheme.primaryLight,
    primaryDark: brandTheme.primaryDark || brandTheme.primary || fallbackTheme.primary,

    success: brandTheme.success || "#10b981",
    successLight: brandTheme.successLight || "rgba(16, 185, 129, 0.10)",

    error: brandTheme.error || "#ef4444",
    errorLight: brandTheme.errorLight || "rgba(239, 68, 68, 0.10)",

    warning: brandTheme.warning || "#f59e0b",
    warningLight: brandTheme.warningLight || "rgba(245, 158, 11, 0.10)",

    gradientPrimary:
      brandTheme.primaryGradient ||
      `linear-gradient(135deg, ${brandTheme.primary || fallbackTheme.primary}, ${
        brandTheme.primaryDark || brandTheme.primary || fallbackTheme.primary
      })`,

    shadowMd: isDark
      ? "0 8px 16px rgba(0, 0, 0, 0.28)"
      : "0 8px 16px rgba(15, 23, 42, 0.08)",

    gradientCard: isDark
      ? `linear-gradient(135deg, ${brandTheme.surfaceLighter || "#334155"} 0%, ${
          brandTheme.surface || "#1e293b"
        } 100%)`
      : `linear-gradient(135deg, ${brandTheme.surface || "#ffffff"} 0%, ${
          brandTheme.background || "#f8fafc"
        } 100%)`,
  };

  const [menuItems, setMenuItems] = useState([]);
  const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [deletingSelected, setDeletingSelected] = useState(false);
  const [updatingDishId, setUpdatingDishId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [availabilityFilter, setAvailabilityFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [showAIScanModal, setShowAIScanModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [vendorMenus, setVendorMenus] = useState([]);
  const [previewMenuImage, setPreviewMenuImage] = useState("");
  const [preSelectedImage, setPreSelectedImage] = useState(null);

  const [markupCommission, setMarkupCommission] = useState(20);
  const [profitCommission, setProfitCommission] = useState(20);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [tempCommission, setTempCommission] = useState(20);

  const savedRestaurant = JSON.parse(
    sessionStorage.getItem("selectedRestaurant") || "{}"
  );

  const designation_id =
    location.state?.designation_id || savedRestaurant.designation_id;

  const [restaurantName, setRestaurantName] = useState(
    location.state?.restaurantName || savedRestaurant.restaurantName || ""
  );

  const fetchRestaurantDetails = async () => {
    if (!designation_id) return;

    try {
      const response = await getData(
        `restaurant/Restrunts/${designation_id}`
      );

      if (response?.status && response?.data) {
        const nameFromApi =
          response.data.organisation_name || response.data.name || "";

        if (nameFromApi) setRestaurantName(nameFromApi);

        const markup =
          parseFloat(response.data.commission_calc) ||
          parseFloat(response.data.comission) ||
          20;

        const profit = parseFloat(response.data.comission) || 20;

        setMarkupCommission(markup);
        setProfitCommission(profit);
      }
    } catch (error) {
      console.error("Failed to fetch restaurant details:", error);
    }
  };

  const fetchMenu = async () => {
    if (!designation_id) return;

    setLoading(true);

    try {
      const response = await postData(
        "restaurant/Menubydesignation_id",
        { designation_id }
      );

      let itemsArray = [];

      if (Array.isArray(response) && response[0]?.items) {
        itemsArray =
          typeof response[0].items === "string"
            ? JSON.parse(response[0].items)
            : response[0].items;
      }

      setMenuItems(itemsArray);
      setSelectedItemIds([]);
    } catch (error) {
      console.error("Failed to fetch menu:", error);
      setMenuItems([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchVendorUploadedMenus = async () => {
    if (!designation_id) return;

    try {
      const response = await getData(
        `menuScanner/requests-by-restaurant/${designation_id}`
      );

      if (response?.success) {
        const allFiles = [];

        response.data.forEach((request) => {
          let files = [];

          try {
            files = Array.isArray(request.files)
              ? request.files
              : JSON.parse(request.files || "[]");
          } catch {
            files = [];
          }

          files.forEach((file) => {
            if (file.type === "image") {
              allFiles.push({
                filename: file.name,
                date: request.created_at,
              });
            }
          });
        });

        setVendorMenus(allFiles);
      }
    } catch (error) {
      console.error("Failed to fetch vendor menus:", error);
    }
  };

  useEffect(() => {
    fetchRestaurantDetails();
    fetchMenu();
    fetchVendorUploadedMenus();
  }, [designation_id]);

  const handleDelete = async (productId) => {
    if (!window.confirm("Bhai, pakka delete karna hai?")) return;

    try {
      const response = await postData(
        `menu/delete-item/${designation_id}/${productId}`,
        {},
        "DELETE"
      );

      if (response?.success) fetchMenu();
    } catch (error) {
      console.error("Failed to delete item:", error);
    }
  };

  const getItemId = (item) => String(item?.product_id ?? item?.id ?? item?.uid ?? "");

  const toggleItemSelection = (item) => {
    const itemId = getItemId(item);
    if (!itemId) return;
    setSelectedItemIds((previous) =>
      previous.includes(itemId)
        ? previous.filter((id) => id !== itemId)
        : [...previous, itemId]
    );
  };

  const togglePageSelection = () => {
    const pageIds = currentItems.map(getItemId).filter(Boolean);
    const allPageItemsSelected = pageIds.length > 0 && pageIds.every((id) => selectedItemIds.includes(id));
    setSelectedItemIds((previous) =>
      allPageItemsSelected
        ? previous.filter((id) => !pageIds.includes(id))
        : [...new Set([...previous, ...pageIds])]
    );
  };

  const handleDeleteSelected = async () => {
    if (selectedItemIds.length === 0 || deletingSelected) return;
    if (!window.confirm(`${selectedItemIds.length} selected dish(es) permanently delete karne hain?`)) return;

    setDeletingSelected(true);
    try {
      const response = await postData(`menu/delete-items/${designation_id}`, {
        product_ids: selectedItemIds,
      });
      if (response?.success) {
        await fetchMenu();
      } else {
        alert(response?.message || "Selected dishes delete nahi ho paaye");
      }
    } catch (error) {
      console.error("Failed to delete selected items:", error);
      alert("Selected dishes delete nahi ho paaye");
    } finally {
      setDeletingSelected(false);
    }
  };

  const handleDishAvailability = async (item) => {
    const productId = item.product_id || item.id;
    if (!productId) return;

    const currentStatus = String(item.status) === "0" ? "0" : "1";
    const nextStatus = currentStatus === "1" ? "0" : "1";
    setUpdatingDishId(String(productId));

    // Update the table immediately, then restore it if the server rejects it.
    setMenuItems((previous) => previous.map((menuItem) =>
      String(menuItem.product_id || menuItem.id) === String(productId)
        ? { ...menuItem, status: nextStatus }
        : menuItem
    ));

    try {
      const response = await putData(
        `restaurant/stock/${designation_id}/${productId}`,
        { status: nextStatus }
      );
      if (!response?.success) {
        setMenuItems((previous) => previous.map((menuItem) =>
          String(menuItem.product_id || menuItem.id) === String(productId)
            ? { ...menuItem, status: currentStatus }
            : menuItem
        ));
        alert(response?.message || "Failed to update dish availability");
      }
    } catch (error) {
      setMenuItems((previous) => previous.map((menuItem) =>
        String(menuItem.product_id || menuItem.id) === String(productId)
          ? { ...menuItem, status: currentStatus }
          : menuItem
      ));
      alert("Failed to update dish availability");
    } finally {
      setUpdatingDishId(null);
    }
  };

  const handlePreviewMenuImage = (filename) => {
    setPreviewMenuImage(filename);
  };

  const handleUpdateCommission = async () => {
    try {
      const response = await postData(
        `restaurant/updaterestaurant/${designation_id}`,
        { commission_calc: tempCommission }
      );

      if (response?.success) {
        setMarkupCommission(tempCommission);
        setShowCommissionModal(false);
        fetchMenu();
      } else {
        alert("Failed to update commission");
      }
    } catch (error) {
      console.error("Error updating commission:", error);
      alert("Error updating commission");
    }
  };

  const getMenuCustomerVendor = (item) => {
    let base =
      parseFloat(item.base_price) ||
      parseFloat(item.requested_price) ||
      0;

    if (!base && item.price) {
      base = Math.round(item.price / 1.2);
    }

    if (!base) {
      return { menu: 0, customer: 0, vendor: 0, profit: 0 };
    }

    const customer = Math.round(base * (1 + markupCommission / 100));
    const profit = Math.round(customer * (profitCommission / 100));
    const vendor = customer - profit;

    return { menu: base, customer, vendor, profit };
  };

  const getVariantPricing = (variant) => {
    let base =
      parseFloat(variant.base_price) ||
      parseFloat(variant.actual_price) ||
      0;

    if (!base && variant.item_price_variant) {
      base = Math.round(variant.item_price_variant / 1.2);
    }

    if (!base) {
      return { menu: 0, customer: 0, vendor: 0, profit: 0 };
    }

    const customer = Math.round(base * (1 + markupCommission / 100));
    const profit = Math.round(customer * (profitCommission / 100));
    const vendor = customer - profit;

    return { menu: base, customer, vendor, profit };
  };

  const filteredItems = useMemo(
    () =>
      menuItems.filter(
        (item) => {
          const matchesSearch =
            item.name?.toLowerCase().includes(search.toLowerCase()) ||
            item.category?.toLowerCase().includes(search.toLowerCase());
          const isActive = String(item.status) !== "0";
          const matchesAvailability =
            availabilityFilter === "all" ||
            (availabilityFilter === "active" && isActive) ||
            (availabilityFilter === "inactive" && !isActive);

          return matchesSearch && matchesAvailability;
        }
      ),
    [menuItems, search, availabilityFilter]
  );

  const totalPages = Math.max(
    1,
    Math.ceil(filteredItems.length / itemsPerPage)
  );

  const currentItems = filteredItems.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const paginationItems = useMemo(() => {
    const pages = [1, currentPage - 1, currentPage, currentPage + 1, totalPages]
      .filter((page) => page >= 1 && page <= totalPages)
      .filter((page, index, array) => array.indexOf(page) === index)
      .sort((first, second) => first - second);

    return pages.reduce((result, page, index) => {
      const previousPage = pages[index - 1];
      if (index > 0 && page - previousPage > 1) result.push("ellipsis");
      result.push(page);
      return result;
    }, []);
  }, [currentPage, totalPages]);

  const styles = {
    container: {
      minHeight: "100vh",
      background: ts.background,
      padding: "32px 40px",
      color: ts.textPrimary,
      fontFamily: "Inter, sans-serif",
      transition: "background 0.3s ease, color 0.3s ease",
    },
    card: {
      background: ts.surface,
      border: `1px solid ${ts.border}`,
      borderRadius: "24px",
      padding: "32px",
      marginBottom: "32px",
      boxShadow: ts.shadowMd,
      backgroundImage: ts.gradientCard,
      transition: "all 0.3s ease",
    },
    vendorGrid: {
      display: "flex",
      gap: "15px",
      overflowX: "auto",
      paddingBottom: "10px",
      marginBottom: "32px",
    },
    vendorImgBox: {
      minWidth: "120px",
      height: "160px",
      borderRadius: "12px",
      border: `2px dashed ${ts.border}`,
      background: ts.surfaceLighter,
      overflow: "hidden",
      cursor: "pointer",
      position: "relative",
      transition: "all 0.2s ease",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      padding: "16px",
      textAlign: "left",
      fontSize: "12px",
      fontWeight: 700,
      color: ts.primary,
      background: ts.surfaceLighter,
      textTransform: "uppercase",
      borderBottom: `1px solid ${ts.border}`,
      whiteSpace: "nowrap",
    },
    td: {
      padding: "14px 16px",
      borderBottom: `1px solid ${ts.border}`,
      fontSize: "13px",
      color: ts.textSecondary,
      verticalAlign: "middle",
    },
    img: {
      width: "50px",
      height: "50px",
      borderRadius: "10px",
      objectFit: "cover",
      border: `1px solid ${ts.border}`,
    },
    paginationBtn: (active) => ({
      padding: "8px 16px",
      borderRadius: "10px",
      border: `1px solid ${active ? ts.primary : ts.border}`,
      background: active ? ts.primary : ts.surface,
      color: active ? "#ffffff" : ts.textSecondary,
      cursor: "pointer",
      margin: "0 4px",
      fontSize: "12px",
      fontWeight: 600,
    }),
    modalOverlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.7)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(4px)",
    },
    modalContent: {
      background: ts.surface,
      padding: "30px",
      borderRadius: "20px",
      maxWidth: "400px",
      width: "90%",
      border: `1px solid ${ts.border}`,
      boxShadow: ts.shadowMd,
    },
  };

  return (
    <div style={styles.container}>
      <style>{`
        tr:hover {
          background: ${ts.primary}08 !important;
        }

        input:focus {
          border-color: ${ts.primary} !important;
          outline: none;
          box-shadow: 0 0 0 3px ${ts.primaryLight};
        }

        .vendor-box:hover .scan-overlay {
          opacity: 1 !important;
        }

        .vendor-box:hover {
          border-color: ${ts.primary} !important;
          transform: translateY(-2px);
        }

        ::-webkit-scrollbar {
          height: 6px;
          width: 6px;
        }

        ::-webkit-scrollbar-thumb {
          background: ${ts.borderAccent};
          border-radius: 10px;
        }
      `}</style>

      <button
        type="button"
        onClick={() => navigate(-1)}
        style={{
          background: ts.surfaceLighter,
          color: ts.primary,
          border: `1px solid ${ts.border}`,
          padding: "10px 20px",
          borderRadius: "12px",
          cursor: "pointer",
          marginBottom: "24px",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          fontWeight: 600,
        }}
      >
        <ChevronLeft size={18} /> Back
      </button>

      <div style={styles.card}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "20px",
          }}
        >
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: "30px",
                fontWeight: 800,
                background: ts.gradientPrimary,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {restaurantName || "Menu"}
            </h1>

            <p style={{ color: ts.textMuted, margin: "5px 0 0" }}>
              Manage dishes and scan new menus
            </p>
          </div>

          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <button
              type="button"
              onClick={() => {
                setTempCommission(markupCommission);
                setShowCommissionModal(true);
              }}
              style={{
                background: ts.surfaceLighter,
                border: `1px solid ${ts.border}`,
                color: ts.textPrimary,
                padding: "10px 20px",
                borderRadius: "12px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: 600,
              }}
            >
              <Percent size={16} color={ts.primary} />
              Markup: {markupCommission}% | Profit: {profitCommission}%
            </button>

            <button
              type="button"
              onClick={() => {
                setPreSelectedImage(null);
                setShowAIScanModal(true);
              }}
              style={{
                background: ts.gradientPrimary,
                color: "#ffffff",
                border: "none",
                padding: "12px 24px",
                borderRadius: "12px",
                fontWeight: "bold",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: `0 4px 12px ${ts.primary}40`,
              }}
            >
              <Sparkles size={16} /> AI Scan Menu
            </button>

<button
  onClick={() => setShowAddItemModal(true)}
 style={{
                background: ts.gradientPrimary,
                color: "#ffffff",
                border: "none",
                padding: "12px 24px",
                borderRadius: "12px",
                fontWeight: "bold",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                boxShadow: `0 4px 12px ${ts.primary}40`,
              }}
>
  <Plus size={16} style={{ verticalAlign: "middle" }} /> Add Item
</button>

          </div>
        </div>
      </div>

      <div
        style={{
          marginBottom: "15px",
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: "8px",
          color: ts.textPrimary,
        }}
      >
        <ImageIcon size={18} color={ts.primary} />
        Menu Pages & PDFs (Vendor + Admin uploads)
      </div>

      <div style={styles.vendorGrid}>
        {vendorMenus.length > 0
          ? vendorMenus.map((menu, index) => (
              <div
                key={`${menu.filename}-${index}`}
                className="vendor-box"
                style={styles.vendorImgBox}
                onClick={() => handlePreviewMenuImage(menu.filename)}
              >
                <img
                  src={`${serverURL}/uploads/${menu.filename}`}
                  alt={`Menu page ${index + 1}`}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  onError={(event) => {
                    event.currentTarget.src =
                      "https://via.placeholder.com/120x160?text=Menu+Page";
                  }}
                />

                <div
                  className="scan-overlay"
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: "rgba(0,0,0,0.6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0,
                    transition: "0.3s",
                  }}
                >
                  <span style={{ color: "#ffffff", fontSize: "12px", fontWeight: 700 }}>
                    Click to view
                  </span>
                </div>

                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    padding: "4px",
                    background: "rgba(0,0,0,0.7)",
                    fontSize: "10px",
                    color: "#ffffff",
                    textAlign: "center",
                  }}
                >
                  Page {index + 1}
                </div>
              </div>
            ))
          : [1, 2, 3, 4, 5].map((page) => (
              <div
                key={page}
                style={{
                  ...styles.vendorImgBox,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  color: ts.textMuted,
                  opacity: 0.5,
                }}
              >
                <Plus size={24} />
                <span style={{ fontSize: "10px", marginTop: "5px" }}>
                  Page {page}
                </span>
              </div>
            ))}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "24px",
          flexWrap: "wrap",
        }}
      >
        <input
          style={{
            flex: "1 1 320px",
            boxSizing: "border-box",
            padding: "14px",
            borderRadius: "14px",
            background: ts.surface,
            border: `1px solid ${ts.border}`,
            color: ts.textPrimary,
            fontSize: "14px",
          }}
          placeholder="Search dish by name..."
          value={search}
          onChange={(event) => {
            setSearch(event.target.value);
            setCurrentPage(1);
          }}
        />
        <select
          aria-label="Filter dishes by availability"
          value={availabilityFilter}
          onChange={(event) => {
            setAvailabilityFilter(event.target.value);
            setCurrentPage(1);
          }}
          style={{
            minWidth: "175px",
            boxSizing: "border-box",
            padding: "14px",
            borderRadius: "14px",
            background: ts.surface,
            border: `1px solid ${ts.border}`,
            color: ts.textPrimary,
            fontSize: "14px",
            cursor: "pointer",
          }}
        >
          <option value="all">All dishes</option>
          <option value="active">Active (ON)</option>
          <option value="inactive">Inactive (OFF)</option>
        </select>
      </div>

      {selectedItemIds.length > 0 && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", marginBottom: "14px", padding: "10px 14px", borderRadius: "10px", background: ts.errorLight, border: `1px solid ${ts.error}33` }}>
          <span style={{ color: ts.error, fontWeight: 700, fontSize: "13px" }}>
            {selectedItemIds.length} dish{selectedItemIds.length > 1 ? "es" : ""} selected
          </span>
          <button
            type="button"
            onClick={handleDeleteSelected}
            disabled={deletingSelected}
            style={{ display: "inline-flex", alignItems: "center", gap: "7px", border: "none", borderRadius: "8px", padding: "8px 12px", cursor: deletingSelected ? "not-allowed" : "pointer", background: ts.error, color: "#fff", fontWeight: 700, opacity: deletingSelected ? 0.65 : 1 }}
          >
            <Trash2 size={15} /> {deletingSelected ? "Deleting..." : "Delete Selected"}
          </button>
        </div>
      )}

      <div style={{ ...styles.card, padding: 0, overflowX: "auto" }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={{ ...styles.th, width: "42px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  aria-label="Select all dishes on this page"
                  checked={currentItems.length > 0 && currentItems.every((item) => selectedItemIds.includes(getItemId(item)))}
                  onChange={togglePageSelection}
                />
              </th>
              <th style={styles.th}>Dish</th>
              <th style={styles.th}>Item Details</th>
              <th style={styles.th}>Menu Price</th>
              <th style={styles.th}>Customer Price</th>
              <th style={styles.th}>Vendor Earns</th>
              <th style={styles.th}>ZaptoDoor Profit</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Availability</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="10"
                  style={{ ...styles.td, textAlign: "center", padding: "35px" }}
                >
                  Loading menu items...
                </td>
              </tr>
            ) : currentItems.length === 0 ? (
              <tr>
                <td
                  colSpan="10"
                  style={{ ...styles.td, textAlign: "center", padding: "35px" }}
                >
                  No menu item found.
                </td>
              </tr>
            ) : (
              currentItems.map((item, index) => {
                let variants = [];

                try {
                  variants = Array.isArray(item.variant)
                    ? item.variant
                    : JSON.parse(item.variant || "[]");
                } catch {
                  variants = [];
                }

                const imageSource = item.pic1?.startsWith("http")
                  ? item.pic1
                  : `${serverURL}/uploads/${item.pic1}`;

                if (variants.length === 0) {
                  const { menu, customer, vendor, profit } =
                    getMenuCustomerVendor(item);

                  return (
                    <tr key={item.product_id || index}>
                      <td style={{ ...styles.td, textAlign: "center" }}>
                        <input
                          type="checkbox"
                          aria-label={`Select ${item.name || "dish"}`}
                          checked={selectedItemIds.includes(getItemId(item))}
                          onChange={() => toggleItemSelection(item)}
                        />
                      </td>
                      <td style={styles.td}>
                        <img
                          src={imageSource}
                          alt={item.name || "Dish"}
                          style={styles.img}
                          onError={(event) => {
                            event.currentTarget.src =
                              "https://via.placeholder.com/50";
                          }}
                        />
                      </td>

                      <td style={styles.td}>
                        <div
                          style={{
                            fontWeight: 700,
                            color: ts.textPrimary,
                            fontSize: "15px",
                          }}
                        >
                          {item.name}
                        </div>
                        <div style={{ fontSize: "11px", color: ts.textMuted }}>
                          {item.description
                            ? `${item.description.substring(0, 40)}...`
                            : item.category || "-"}
                        </div>
                      </td>

                      <td style={styles.td}>
                        <strong style={{ color: ts.textPrimary }}>
                          ₹{menu.toFixed(0)}
                        </strong>
                      </td>

                      <td style={styles.td}>
                        <strong style={{ color: ts.warning }}>
                          ₹{customer.toFixed(0)}
                        </strong>
                      </td>

                      <td style={styles.td}>
                        <strong style={{ color: ts.success }}>
                          ₹{vendor.toFixed(0)}
                        </strong>
                      </td>

                      <td style={styles.td}>
                        <strong style={{ color: ts.primary }}>
                          +₹{profit.toFixed(0)}
                        </strong>
                      </td>

                      <td style={styles.td}>
                        <span
                          style={{
                            padding: "4px 10px",
                            borderRadius: "8px",
                            background:
                              item.is_veg === "yes" ? "#065f46" : "#991b1b",
                            color: "#ffffff",
                            fontSize: "10px",
                            fontWeight: 700,
                          }}
                        >
                          {item.is_veg === "yes" ? "VEG" : "NON-VEG"}
                        </span>
                      </td>

                      <td style={styles.td}>
                        <button
                          type="button"
                          disabled={updatingDishId === String(item.product_id || item.id)}
                          onClick={() => handleDishAvailability(item)}
                          style={{
                            minWidth: "56px", border: "none", borderRadius: "999px",
                            padding: "6px 10px", cursor: "pointer", fontWeight: 700,
                            color: "#ffffff",
                            background: String(item.status) === "0" ? ts.warning : ts.success,
                            opacity: updatingDishId === String(item.product_id || item.id) ? 0.6 : 1,
                          }}
                        >
                          {updatingDishId === String(item.product_id || item.id)
                            ? "..."
                            : String(item.status) === "0" ? "OFF" : "ON"}
                        </button>
                      </td>

                      <td style={styles.td}>
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedItem(item);
                              setShowEditModal(true);
                            }}
                            style={{
                              background: "none",
                              border: "none",
                              color: ts.primary,
                              cursor: "pointer",
                              padding: "4px",
                            }}
                          >
                            <Sparkles size={14} />
                          </button>

                          <button
                            type="button"
                            onClick={() => handleDelete(item.product_id)}
                            style={{
                              background: "none",
                              border: "none",
                              color: ts.error,
                              cursor: "pointer",
                              padding: "4px",
                            }}
                          >
                            <X size={14} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                }

                return (
                  <tr key={item.product_id || index}>
                    <td style={{ ...styles.td, textAlign: "center" }}>
                      <input
                        type="checkbox"
                        aria-label={`Select ${item.name || "dish"}`}
                        checked={selectedItemIds.includes(getItemId(item))}
                        onChange={() => toggleItemSelection(item)}
                      />
                    </td>
                    <td style={styles.td}>
                      <img
                        src={imageSource}
                        alt={item.name || "Dish"}
                        style={styles.img}
                        onError={(event) => {
                          event.currentTarget.src =
                            "https://via.placeholder.com/50";
                        }}
                      />
                    </td>

                    <td style={styles.td}>
                      <div
                        style={{
                          fontWeight: 700,
                          color: ts.textPrimary,
                          fontSize: "15px",
                          marginBottom: "7px",
                        }}
                      >
                        {item.name}
                      </div>

                      {variants.map((variant, variantIndex) => (
                        <div
                          key={variantIndex}
                          style={{
                            fontSize: "11px",
                            color: ts.textMuted,
                            marginBottom: "4px",
                          }}
                        >
                          {variant.variant_name ||
                            variant.name ||
                            `Variant ${variantIndex + 1}`}
                        </div>
                      ))}
                    </td>

                    <td style={styles.td}>
                      {variants.map((variant, variantIndex) => {
                        const pricing = getVariantPricing(variant);

                        return (
                          <div
                            key={variantIndex}
                            style={{
                              marginBottom:
                                variantIndex !== variants.length - 1
                                  ? "7px"
                                  : 0,
                              color: ts.textPrimary,
                              fontWeight: 600,
                            }}
                          >
                            ₹{pricing.menu.toFixed(0)}
                          </div>
                        );
                      })}
                    </td>

                    <td style={styles.td}>
                      {variants.map((variant, variantIndex) => {
                        const pricing = getVariantPricing(variant);

                        return (
                          <div
                            key={variantIndex}
                            style={{
                              marginBottom:
                                variantIndex !== variants.length - 1
                                  ? "7px"
                                  : 0,
                              color: ts.warning,
                              fontWeight: 700,
                            }}
                          >
                            ₹{pricing.customer.toFixed(0)}
                          </div>
                        );
                      })}
                    </td>

                    <td style={styles.td}>
                      {variants.map((variant, variantIndex) => {
                        const pricing = getVariantPricing(variant);

                        return (
                          <div
                            key={variantIndex}
                            style={{
                              marginBottom:
                                variantIndex !== variants.length - 1
                                  ? "7px"
                                  : 0,
                              color: ts.success,
                              fontWeight: 700,
                            }}
                          >
                            ₹{pricing.vendor.toFixed(0)}
                          </div>
                        );
                      })}
                    </td>

                    <td style={styles.td}>
                      {variants.map((variant, variantIndex) => {
                        const pricing = getVariantPricing(variant);

                        return (
                          <div
                            key={variantIndex}
                            style={{
                              marginBottom:
                                variantIndex !== variants.length - 1
                                  ? "7px"
                                  : 0,
                              color: ts.primary,
                              fontWeight: 700,
                            }}
                          >
                            +₹{pricing.profit.toFixed(0)}
                          </div>
                        );
                      })}
                    </td>

                    <td style={styles.td}>
                      <span
                        style={{
                          padding: "4px 10px",
                          borderRadius: "8px",
                          background:
                            item.is_veg === "yes" ? "#065f46" : "#991b1b",
                          color: "#ffffff",
                          fontSize: "10px",
                          fontWeight: 700,
                        }}
                      >
                        {item.is_veg === "yes" ? "VEG" : "NON-VEG"}
                      </span>
                    </td>

                    <td style={styles.td}>
                      <button
                        type="button"
                        disabled={updatingDishId === String(item.product_id || item.id)}
                        onClick={() => handleDishAvailability(item)}
                        style={{
                          minWidth: "56px", border: "none", borderRadius: "999px",
                          padding: "6px 10px", cursor: "pointer", fontWeight: 700,
                          color: "#ffffff",
                          background: String(item.status) === "0" ? ts.warning : ts.success,
                          opacity: updatingDishId === String(item.product_id || item.id) ? 0.6 : 1,
                        }}
                      >
                        {updatingDishId === String(item.product_id || item.id)
                          ? "..."
                          : String(item.status) === "0" ? "OFF" : "ON"}
                      </button>
                    </td>

                    <td style={styles.td}>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          type="button"
                          onClick={() => {
                            setSelectedItem(item);
                            setShowEditModal(true);
                          }}
                          style={{
                            background: "none",
                            border: "none",
                            color: ts.primary,
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          <Sparkles size={14} />
                        </button>

                        <button
                          type="button"
                          onClick={() => handleDelete(item.product_id)}
                          style={{
                            background: "none",
                            border: "none",
                            color: ts.error,
                            cursor: "pointer",
                            padding: "4px",
                          }}
                        >
                          <X size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {filteredItems.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "16px",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          <label
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              color: ts.textSecondary,
              fontSize: "13px",
              fontWeight: 600,
            }}
          >
            Rows per page
            <select
              aria-label="Rows per page"
              value={itemsPerPage}
              onChange={(event) => {
                setItemsPerPage(Number(event.target.value));
                setCurrentPage(1);
              }}
              style={{
                padding: "8px 10px",
                borderRadius: "8px",
                border: `1px solid ${ts.border}`,
                background: ts.surface,
                color: ts.textPrimary,
                cursor: "pointer",
              }}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </label>

          {filteredItems.length > itemsPerPage && (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <button
                type="button"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
                style={{
                  ...styles.paginationBtn(false),
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <ChevronLeft size={16} />
              </button>

              {paginationItems.map((page, index) =>
                page === "ellipsis" ? (
                  <span key={`ellipsis-${index}`} style={{ color: ts.textMuted, padding: "0 3px" }}>
                    …
                  </span>
                ) : (
                  <button
                    type="button"
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    style={styles.paginationBtn(currentPage === page)}
                  >
                    {page}
                  </button>
                )
              )}

              <button
                type="button"
                disabled={currentPage === totalPages}
                onClick={() =>
                  setCurrentPage((page) => Math.min(totalPages, page + 1))
                }
                style={{
                  ...styles.paginationBtn(false),
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                <ChevronRight size={16} />
              </button>
            </div>
          )}
        </div>
      )}
{showAddItemModal && (
  <AddItemModal
    isOpen={showAddItemModal}
    onClose={() => setShowAddItemModal(false)}
    designation_id={designation_id}
    markupCommission={markupCommission}
    profitCommission={profitCommission}
    onSuccess={() => {
      setShowAddItemModal(false);
      fetchMenu();
    }}
  />
)}
      {previewMenuImage && (
        <div
          style={{ ...styles.modalOverlay, zIndex: 10001, padding: "24px" }}
          onClick={() => setPreviewMenuImage("")}
        >
          <div
            onClick={(event) => event.stopPropagation()}
            style={{
              position: "relative",
              maxWidth: "95vw",
              maxHeight: "92vh",
              padding: "12px",
              borderRadius: "16px",
              background: ts.surface,
              boxShadow: ts.shadowMd,
            }}
          >
            <button
              type="button"
              aria-label="Close menu preview"
              onClick={() => setPreviewMenuImage("")}
              style={{
                position: "absolute",
                top: "-14px",
                right: "-14px",
                width: "36px",
                height: "36px",
                display: "grid",
                placeItems: "center",
                border: "none",
                borderRadius: "50%",
                background: ts.error,
                color: "#ffffff",
                cursor: "pointer",
                boxShadow: ts.shadowMd,
              }}
            >
              <X size={20} />
            </button>
            <img
              src={`${serverURL}/uploads/${previewMenuImage}`}
              alt="Full menu preview"
              style={{
                display: "block",
                maxWidth: "calc(95vw - 48px)",
                maxHeight: "calc(92vh - 48px)",
                objectFit: "contain",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
      )}
      {showCommissionModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "20px",
              }}
            >
              <h3 style={{ margin: 0, color: ts.textPrimary }}>
                Update Markup Commission
              </h3>

              <button
                type="button"
                onClick={() => setShowCommissionModal(false)}
                style={{
                  border: "none",
                  background: "transparent",
                  color: ts.textMuted,
                  cursor: "pointer",
                }}
              >
                <X size={20} />
              </button>
            </div>

            <label
              style={{
                display: "block",
                color: ts.textSecondary,
                fontSize: "13px",
                marginBottom: "8px",
              }}
            >
              Markup commission (%)
            </label>

            <input
              type="number"
              min="0"
              value={tempCommission}
              onChange={(event) => setTempCommission(event.target.value)}
              style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "12px",
                borderRadius: "10px",
                background: ts.surfaceLighter,
                border: `1px solid ${ts.border}`,
                color: ts.textPrimary,
                fontSize: "15px",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "24px",
              }}
            >
              <button
                type="button"
                onClick={() => setShowCommissionModal(false)}
                style={{
                  background: ts.surfaceLighter,
                  color: ts.textPrimary,
                  border: `1px solid ${ts.border}`,
                  borderRadius: "10px",
                  padding: "10px 16px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleUpdateCommission}
                style={{
                  background: ts.gradientPrimary,
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "10px",
                  padding: "10px 16px",
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {showAIScanModal && (
        <AIScanModal
          isOpen={showAIScanModal}
          onClose={() => {
            setShowAIScanModal(false);
            setPreSelectedImage(null);
          }}
          designation_id={designation_id}
          preSelectedImage={preSelectedImage}
          onSuccess={() => {
            setShowAIScanModal(false);
            setPreSelectedImage(null);
            fetchMenu();
            fetchVendorUploadedMenus();
          }}
        />
      )}

      {showEditModal && selectedItem && (
        <EditItemModal
          isOpen={showEditModal}
          item={selectedItem}
          designation_id={designation_id}
          onClose={() => {
            setShowEditModal(false);
            setSelectedItem(null);
          }}
          onSuccess={() => {
            setShowEditModal(false);
            setSelectedItem(null);
            fetchMenu();
          }}
        />
      )}
    </div>
  );
};

export default Admin;
